// The webui session rides a SESSION cookie (ratified 2026-07-12): unlike localStorage
// it dies with the browser. It holds the opaque tvts_ token plus the display identity
// the dashboard shows — the cookie is the client's convenience store, the API remains
// the authority (bearer header, spec §3).

export const SESSION_COOKIE = 'tvirt-session'

export type WebuiSession = {
  token: string
  username: string
  realm: string
  displayName: string
}

export function getSession(): WebuiSession | null {
  if (typeof document === 'undefined') {
    return null
  }

  const entry = document.cookie.split('; ').find(part => part.startsWith(`${SESSION_COOKIE}=`))

  if (!entry) {
    return null
  }

  try {
    return JSON.parse(decodeURIComponent(entry.slice(SESSION_COOKIE.length + 1)))
  } catch {
    return null
  }
}

export function setSession(session: WebuiSession) {
  // No expires/max-age: a session cookie, cleared when the browser closes.
  document.cookie = `${SESSION_COOKIE}=${encodeURIComponent(JSON.stringify(session))}; path=/; samesite=lax`
}

export function clearSession() {
  document.cookie = `${SESSION_COOKIE}=; path=/; samesite=lax; max-age=0`
}
